import axios from "axios";

const BASE_API_URL = "/api/question";

//提問（白夜）service
//
//  全部要登入 —— 券是發在帳號上的，沒有帳號就沒有券可以扣。
//
//  問事券本身是在金流那邊買的（PaymentService.checkout 搭 type "ask"）；
//  這裡做的是「用掉一張券」。
//
//  跟 divination-service 幾乎一樣，刻意分開而不是共用一支泛型的 ——
//  兩邊的回傳欄位不同（divinations / questions、gua / answer），
//  共用的話呼叫端要一直傳「我是哪一種」，那比多一支檔案難讀。
class QuestionService {
  //Q-1 我問過的（列表，一次十筆、新的在前）
  //
  //  回 { questions, hasMore, nextBefore }。
  //  往回翻就把上一次的 nextBefore 原樣傳回去 —— 它是「比這個時刻更早的」。
  //
  //  為什麼不是 page 編號：兩頁之間使用者又問了一題的話，整串會往後位移一格，
  //  第二頁會把第一頁的最後一筆再給一次。
  list(before) {
    return axios.get(`${BASE_API_URL}/list`, {
      params: before ? { before } : {},
    });
  }

  //Q-2 單一提問
  //  答案是背景生成的，所以送出之後要靠這支輪詢「答好了沒」
  //  （status 從 asking 變成 done 或 failed）。
  get(questionID) {
    return axios.get(`${BASE_API_URL}/${questionID}`);
  }

  //Q-3 問一題：扣一張問事券，建一筆提問
  //
  //  回 { question, remain }。remain 是扣完之後剩幾張 ——
  //  帶回來前端就不用再打一次 /tickets（而且那樣有時序問題：
  //  兩支請求並行的話餘額可能顯示成扣之前的數字）。
  //
  //  兩種失敗後端都回 status: false，呼叫端要分開處理：
  //    「沒有問事券了」            → 導去購券分頁
  //    「請先補齊出生年月日…」      → 跳個人資料的 dialog
  //  前端在送出前也各擋一次，但那只是體驗 —— 真正的把關在後端。
  create(question) {
    return axios.post(BASE_API_URL, { question });
  }
}

const questionService = new QuestionService();
export default questionService;
